/**
 * Sposoby przekazania świadczenia
 *
 * @export
 * @enum {number}
 */
export enum PaymentType {
  AUTOPAYMENT = 'AUTOPAYMENT',
  BANK_ACCOUNT = 'BANK_ACCOUNT',
  ARTISTIC = 'ARTISTIC',
  ELEMENTARY = 'ELEMENTARY',
  ABOVE_ELEMENTARY = 'ABOVE_ELEMENTARY',
  UKRAINE = 'UKRAINE',
  STANDARD = 'STANDARD',
  UKRAINE_AUTOPAYMENT = 'UKRAINE_AUTOPAYMENT',
  UKRAINE_BANK_ACCOUNT = 'UKRAINE_BANK_ACCOUNT'
}

/**
 * Tłumacenia sposobów przekazania świadczenia
 *
 * @export
 * @enum {number}
 */
export enum PaymentTypeTranslations {
  AUTOPAYMENT = 'Autowypłata',
  BANK_ACCOUNT = 'Przelew bankowy',
  ARTISTIC = 'Konkursy artystyczne',
  ELEMENTARY = 'Konkursy wiedzowe - szkoły podstawowe',
  ABOVE_ELEMENTARY = 'Konkursy wiedzowe - szkoły ponadpodstawowe',
  UKRAINE = 'Wnioski UA',
  STANDARD = 'Ogólna',
  UKRAINE_AUTOPAYMENT = 'Autowypłata - UA',
  UKRAINE_BANK_ACCOUNT = 'Przelew bankowy - UA'
}
